import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, of, switchMap, tap, withLatestFrom } from 'rxjs';
import { ReferenceService } from '../../../../generated/auth/services/reference.service';
import { loadGenderList, loadListFailure, loadListSuccess, toggleLoadingStatus } from './store.actions';
import { selectGenderIsLoading, selectGenderList } from './store.selectors';

@Injectable()
export class GenderEffect {
  private readonly action = inject(Actions);
  private readonly service = inject(ReferenceService);
  private readonly store = inject(Store);

  constructor() {}

  loadList = createEffect(() =>
    this.action.pipe(
      ofType(loadGenderList),
      withLatestFrom(this.store.select(selectGenderList), this.store.select(selectGenderIsLoading)),
      filter(([action, state, status]) => !state?.length && !status),
      tap(() => this.store.dispatch(toggleLoadingStatus({ status: true }))),
      switchMap((action) =>
        this.service.referenceLookupGetGendersGet().pipe(
          switchMap((response) => of(loadListSuccess({ payload: response.result }))),
          catchError((error) => of(loadListFailure({ error }))),
        ),
      ),
    ),
  );
}
